import React from "react";
import {Link, NavLink} from "react-router-dom";

const navItems = [
    {label: "Work", to: "/portfolio"},
    {label: "About", to: "/about"},
    {label: "Contact", to: "/contact"}
];

const headerLogo = "/assets/img/kjnlogoFullSize.png";

function SiteNav() {
    return (
        <header className="modern-nav">
            <Link className="modern-brand" to="/" aria-label="Kevin J Nichols home">
                <img className="modern-brand-logo" src={headerLogo} alt="" aria-hidden="true"/>
                <strong>Kevin J Nichols</strong>
            </Link>

            <nav id="modern-navigation" aria-label="Primary navigation">
                {navItems.map((item) => (
                    <NavLink
                        key={item.to}
                        to={item.to}
                        className={({isActive}) => isActive ? "is-active" : ""}
                    >
                        {item.label}
                    </NavLink>
                ))}
                <Link className="modern-nav-cta" to="/contact">Hire</Link>
            </nav>
        </header>
    );
}

export default SiteNav;
